import { validateBreakRuleSetConditions } from '@services/ruleSet';

/* eslint-disable no-unused-vars */
const informationStatusOnOpen = (ruleSet) => (ruleSet.name ? 'finish' : 'wait');

const sortingRulesStatusOnOpen = ({ dataviewId }) => (dataviewId ? 'finish' : 'wait');

const breakRulesStatusOnOpen = (ruleSet) => (
    validateBreakRuleSetConditions(ruleSet.conditions)
        ? 'finish'
        : 'wait');

const exceptionRulesStatusOnOpen = (ruleSet) => 'wait';

const getStepsCompletion = (ruleSet) => ({
    informationStatus: informationStatusOnOpen(ruleSet),
    parametersStatus: sortingRulesStatusOnOpen(ruleSet),
    conditionsStatus: breakRulesStatusOnOpen(ruleSet),
    exceptionRulesStatus: exceptionRulesStatusOnOpen(ruleSet),
});

export const recomputeInformationStatus = (errors, name) => {
    if (errors.name) {
        return 'error';
    }
    return name ? 'finish' : 'wait';
};

/**
 * @param {Partial<{ dataviewId: string, sortingRulesDataviewFields: * }>} errors
 * @param {number} selectedFieldsCount
 */
export const recomputeSortingRulesStatus = (errors, dataviewId, selectedFieldsCount) => {
    if (errors.dataviewId || errors.sortingRulesDataviewFields) {
        return 'error';
    }

    return dataviewId && selectedFieldsCount ? 'finish' : 'wait';
};

export const recomputeBreakRulesStatus = (errors, conditions) => {
    const conditionsValid = validateBreakRuleSetConditions(conditions);
    if (!conditionsValid) {
        return 'error';
    }

    return conditionsValid ? 'finish' : 'wait';
};

export const recomputeExceptionRulesStatus = () => 'wait';

export default getStepsCompletion;
